import { render, staticRenderFns } from "./AddressControl.vue?vue&type=template&id=03ef49d4&"
import script from "./AddressControl.vue?vue&type=script&lang=js&"
export * from "./AddressControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports